import { memo, useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import AssetWalletDetail from '../AssetWalletDetail'
import Web3WalletDetail from '../Web3WalletDetail'
import BreadcrumbLayout from '@/components/BreadcrumbLayout'
import walletApi from '@/services/apis/wallet'
import { Web3WalletItemModel, WalletItemModel } from '@/services/apis/wallet/models'
import emitter from '@/utils/event'
import { REFRESH_WALLET_DETAIL_EVENT } from '@/constants/event'

const WalletDetail = () => {
  const { walletKey = '' } = useParams()
  const [accountKey, web3Flag] = walletKey.split('_')
  const [data, setData] = useState<Web3WalletItemModel | WalletItemModel>()
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    if (!accountKey) {
      return
    }
    if (web3Flag) {
      setIsLoading(true)
      walletApi
        .getWeb3VaultAccountDetail({ accountKey })
        .then(res => {
          if (res.success && res.data) {
            setData(res.data)
          }
        })
        .finally(() => setIsLoading(false))
      return
    }
    const fn = () => {
      setIsLoading(true)
      walletApi
        .getVaultAccountDetail({ accountKey })
        .then(res => {
          if (res.success && res.data) {
            setData(res.data)
          }
        })
        .finally(() => setIsLoading(false))
    }
    fn()
    emitter.on(REFRESH_WALLET_DETAIL_EVENT, fn)
    return () => emitter.off(REFRESH_WALLET_DETAIL_EVENT, fn)
  }, [accountKey, web3Flag])
  if (!web3Flag) {
    return (
      <BreadcrumbLayout params={{ [walletKey]: data?.accountName ?? '' }}>
        <AssetWalletDetail wallet={data as WalletItemModel} isLoading={isLoading} />
      </BreadcrumbLayout>
    )
  }
  if (web3Flag) {
    return (
      <BreadcrumbLayout params={{ [walletKey]: data?.accountName ?? '' }}>
        <Web3WalletDetail walletKey={accountKey} wallet={data as Web3WalletItemModel} />
      </BreadcrumbLayout>
    )
  }
  return null
}

export default memo(WalletDetail)
